<div class="statusTag" [class.active]="isRecording()">
	<div class="dot"></div>
	{{ T.LABEL_REC | translate }}
</div>
